import { render, staticRenderFns } from "./ChatCustomHome.vue?vue&type=template&id=04786a05&"
import script from "./ChatCustomHome.vue?vue&type=script&lang=js&"
export * from "./ChatCustomHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatCustomHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports